import { render, staticRenderFns } from "./AddFamilyModal.vue?vue&type=template&id=a4466e20&scoped=true"
import script from "./AddFamilyModal.vue?vue&type=script&lang=js"
export * from "./AddFamilyModal.vue?vue&type=script&lang=js"
import style0 from "./AddFamilyModal.vue?vue&type=style&index=0&id=a4466e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4466e20",
  null
  
)

export default component.exports